import clsx from "clsx";
import { FunctionComponent } from "react";

import LiveBadge from "@ui/components/meta/LiveBadge";

import * as styles from "./StickyNav.css";
import { StickyNavContentProps } from "./types";

interface Props extends StickyNavContentProps {
  streamHeadline?: string;
  streamUrl?: string;
  packageHeadline?: string;
  packageUrl?: string;
  isLive?: boolean;
}

const StickyNavAltTitleContent: FunctionComponent<Props> = ({
  Logo,
  streamHeadline,
  streamUrl,
  packageHeadline,
  packageUrl,
  hamburgerButton,
  commentCount,
  isLive,
}) => {
  const useStream = !!(isLive && streamHeadline) || !packageHeadline;
  const headline = useStream ? streamHeadline : packageHeadline;
  const link = useStream ? streamUrl : packageUrl;
  return (
    <div className={clsx(styles.standardInnerContainer)}>
      <a
        href="/"
        aria-label="Click to visit the homepage"
        tabIndex={-1}
        className={clsx(styles.logoContainer, styles.streamLogoContainer)}
      >
        <Logo className={clsx(styles.logo)} />
      </a>
      {headline && (
        <div className={styles.streamHeadlineContainer}>
          {isLive && <LiveBadge variation="card" />}
          <a
            href={link}
            target="_blank"
            className={clsx(styles.headline, styles.streamHeadline)}
            rel="noreferrer"
          >
            {headline}
          </a>
        </div>
      )}
      <div className={styles.rightMenu}>
        {commentCount}
        {hamburgerButton}
      </div>
    </div>
  );
};

export default StickyNavAltTitleContent;
